import { render, staticRenderFns } from "./input-restrict-length.vue?vue&type=template&id=75b453d0&"
import script from "./input-restrict-length.vue?vue&type=script&lang=ts&"
export * from "./input-restrict-length.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports